import {ATTRIBUTE_MULTIPLE_VALUE_TYPES} from '../constants';
import {type AttributeTemplateType} from '../schema';

/**
 * Is multi value attribute template type
 * @param type Attribute template type
 * @return Is multivalue
 */
export const isMultiValue = (type: AttributeTemplateType) =>
	ATTRIBUTE_MULTIPLE_VALUE_TYPES.includes(type);

export default isMultiValue;
